import { 
  collection, 
  getDocs, 
  doc, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc,
  query,
  orderBy,
  Timestamp
} from 'firebase/firestore';
import { db } from './config';

const TOPICS_COLLECTION = 'topics';

// جلب جميع المواضيع
export const getAllTopics = async () => {
  try {
    const topicsCol = collection(db, TOPICS_COLLECTION);
    const q = query(topicsCol, orderBy('createdAt', 'desc'));
    const topicsSnapshot = await getDocs(q);
    const topicsList = topicsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return topicsList;
  } catch (error) {
    console.error('Error getting topics:', error);
    return [];
  }
};

// جلب موضوع واحد
export const getTopic = async (topicId) => {
  try {
    const topicDoc = doc(db, TOPICS_COLLECTION, topicId);
    const topicSnapshot = await getDoc(topicDoc);
    if (topicSnapshot.exists()) {
      return {
        id: topicSnapshot.id,
        ...topicSnapshot.data()
      };
    }
    return null;
  } catch (error) {
    console.error('Error getting topic:', error);
    return null;
  }
};

// إضافة موضوع جديد
export const addTopic = async (topicData) => {
  try {
    const topicsCol = collection(db, TOPICS_COLLECTION);
    const newTopic = {
      ...topicData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      views: 0
    };
    const docRef = await addDoc(topicsCol, newTopic);
    return {
      id: docRef.id,
      ...newTopic
    };
  } catch (error) {
    console.error('Error adding topic:', error);
    throw error;
  }
};

// تحديث موضوع
export const updateTopic = async (topicId, topicData) => {
  try {
    const topicDoc = doc(db, TOPICS_COLLECTION, topicId);
    const updateData = {
      ...topicData,
      updatedAt: Timestamp.now()
    };
    await updateDoc(topicDoc, updateData);
    return {
      id: topicId,
      ...updateData
    };
  } catch (error) {
    console.error('Error updating topic:', error);
    throw error;
  }
};

// حذف موضوع
export const deleteTopic = async (topicId) => {
  try {
    const topicDoc = doc(db, TOPICS_COLLECTION, topicId);
    await deleteDoc(topicDoc);
    return true;
  } catch (error) {
    console.error('Error deleting topic:', error);
    throw error;
  }
};

// زيادة عدد المشاهدات
export const incrementTopicViews = async (topicId) => {
  try {
    const topicDoc = doc(db, TOPICS_COLLECTION, topicId);
    const topicSnapshot = await getDoc(topicDoc);
    if (topicSnapshot.exists()) {
      const currentViews = topicSnapshot.data().views || 0;
      await updateDoc(topicDoc, {
        views: currentViews + 1
      });
    }
  } catch (error) {
    console.error('Error incrementing views:', error);
  }
};
